import React, { Component } from 'react'

export default class Timeline extends Component {
  render() {
    return (
      <div>
        <section className="colorlib-experience" data-section="timeline">
          <div className="colorlib-narrow-content">
            <div className="row">
              <div className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box" data-animate-effect="fadeInLeft">
                <span className="heading-meta">highlights</span>
                <h2 className="colorlib-heading animate-box">Timeline</h2>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="timeline-centered">
                  <article className="timeline-entry animate-box" data-animate-effect="fadeInLeft">
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-3">
                        <i className="icon-pen2" />
                      </div>
                      <div className="timeline-label">
                        <h2>Consultant at Atos <span>2015-present</span></h2>
                        <p>• Expertise in full project life cycle development for implementation and integration. <br></br>
                          • Key responsibilities in projects include module design, coding, implementation, unit testing and client communication and reviewing.<br></br>
                          • Implementation of n-Tier Component based application for iOS native.<br></br>
                          • Experience in developing iPhone application for a wide array of mobile devices.<br></br>
                          • Experience in developing React JS web application for a web and mobile.<br></br>
                          • Experience in client-server application development along with Web Services implementation.<br></br>
                          • Excellent organisational and interpersonal skills with a strong technical background.</p>
                      </div>
                    </div>
                  </article>
                  <article className="timeline-entry animate-box" data-animate-effect="fadeInTop">
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-4">
                        <i className="icon-pen2" />
                      </div>
                      <div className="timeline-label">
                        <h2> SurveyAnalytics <span>2012-2015</span></h2>
                        <p>Worked as lead product engineer at mobile applications. Involved in product design and architecture of mobile application. Handled responsibilities of mobile applications product delivery and deployment for various client of SA.</p>
                      </div>
                    </div>
                  </article>
                  <article className="timeline-entry animate-box" data-animate-effect="fadeInLeft">
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-5">
                        <i className="icon-pen2" />
                      </div>
                      <div className="timeline-label">
                        <h2>Avibha IT Solutions <span>2010-2011</span></h2>
                        <p>Worked as lead Mobile developer and technical lead of mobile team. Involved in project design and architecture of mobile application. Handled responsibilities of project delivery and deployment for various client with project planning and execution.</p> 
                      </div>
                    </div>
                  </article>
                  <article className="timeline-entry animate-box" data-animate-effect="fadeInLeft">
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-6">
                        <i className="icon-pen2" />
                      </div>
                      <div className="timeline-label">
                        <h2>Xerces Technologies Pvt. Ltd <span>2010-2011</span></h2>
                        <p>Worked as iOS developer and involved in various phases of the development of iOS application. Developed various small application and mobile games.</p>
                      </div>
                    </div>
                  </article>
                  <article className="timeline-entry begin animate-box" data-animate-effect="fadeInBottom">
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-none">
                      </div>
                    </div>
                  </article>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    )
  }
}
